<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca47"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="subLedgerList_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="subLedgerList_statusQuery_button" @click="statusQuery">
          更新分账结果
        </el-button>
        <el-button
          v-if="getLimit('subLedgerList_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="relateOrderNo"
          title="原支付订单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.relateOrderNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="outTradeNo"
          title="交易流水号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outTradeNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shareOrderNo"
          title="网商分账订单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shareOrderNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyName"
          title="收款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.partyName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyPhone"
          title="收款人手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.partyPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalAmount"
          title="金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <!--      <vxe-table-column>-->
      <!--        <vxe-table-column-->
      <!--          field="mainOrderNumber"-->
      <!--          title="货源单号"-->
      <!--          -->
      <!--          -->
      <!--          min-width="250"-->
      <!--          sortable-->
      <!--        />-->
      <!--        <template v-slot:header>-->
      <!--          <el-input v-model="listQuery.mainOrderNumber" placeholder="请输入内容" clearable />-->
      <!--        </template>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          field="errorCode"
          title="错误码"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorCode"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorDesc"
          title="错误描述"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorDesc"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="memo" title="备注" min-width="250" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.memo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="subLedgerList_rePayment_button && scope.row.status == 'FAIL'"
            class="item"
            effect="dark"
            content="重新分账"
            placement="top"
          >
            <vxe-button type="text" @click="rePayment(scope.row)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              subLedgerList_orderShare_button && scope.row.status == 'DEALING'
            "
            class="item"
            effect="dark"
            content="更新分账结果"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="orderShare(scope.row.relateOrderNo)"
            >
              <i class="el-icon-c-scale-to-original" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import {
  mybankOrderShare,
  orderShareApply,
  orderShareQuery
} from "@/api/InternetBanking";

export default {
  data() {
    return {
      exportObj: {
        exportUrl: "ntocc-tms-api/mybankOrderShare/exportMyBankOrderShare", //导出接口
        name: "分账记录"
      },
      loading: false,
      dialogTableVisible: false,
      subLedgerList_search_button: false, //查询
      subLedgerList_statusQuery_button: false, //更新分账结果
      subLedgerList_rePayment_button: false, //重新分账
      subLedgerList_orderShare_button: false, //更新分账结果
      tableData: [],
      errorData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      statusOptions: [
        { value: "SUCCESS", label: "成功" },
        { value: "FAIL", label: "失败" },
        { value: "DEALING", label: "处理中" }
      ],
      Reclassification: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
    this.subLedgerList_search_button = getLimit("subLedgerList_search_button");
    this.subLedgerList_statusQuery_button = getLimit(
      "subLedgerList_statusQuery_button"
    );
    this.subLedgerList_rePayment_button = getLimit(
      "subLedgerList_rePayment_button"
    );
    this.subLedgerList_orderShare_button = getLimit(
      "subLedgerList_orderShare_button"
    );
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        mybankOrderShare(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    //更新分账结果
    statusQuery() {
      const rLoading = this.openLoading();
      orderShareQuery().then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    //重新分账
    rePayment(c) {
      this.Reclassification = [];
      this.Reclassification.push({
        relateOrderNo: c.relateOrderNo,
        shareType: c.shareType
      });
      this.$confirm("是否重新分账?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          orderShareApply(this.Reclassification).then(response => {
            rLoading.close();
            if (response.status === 500) {
              this.dialogTableVisible = true;
              this.errorData = response.data;
            } else {
              let type = response.status === 0 ? "success" : "error";
              this.findList();
              this.$message({
                message: response.msg,
                type: type
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //查询网商分账结果
    orderShare(c) {
      const rLoading = this.openLoading();
      orderShareQuery(c).then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    }
  }
};
</script>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

::v-deep .el-dialog {
  margin: 0 auto !important;
  height: 60%;
  width: 32%;
  overflow: hidden;
}

::v-deep .el-dialog .el-dialog__body {
  position: absolute;
  left: 10px;
  top: 58px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
</style>
